import { useState } from "react";

import { GetUsefulContacts } from 'services/myVehicles/getUsefulContacts';
import { PostUpdatePlate } from 'services/myVehicles/postUpdatePlate';

import { ParamsDataUsefulContacts, ParamsBodyUpdatePlate, ParamsDataUpdatePlate } from 'utils/typeServices';

const useMyVehicles = () => {
    const [dataUsefulContacts, setDataUsefulContacts] = useState<ParamsDataUsefulContacts>();
    const [dataUpdatePlate, setDataUpdatePlate] = useState<ParamsDataUpdatePlate>();

    const handleClearVehicles = () => {
        setDataUsefulContacts(undefined);
        setDataUpdatePlate(undefined);
    }

    const handleGetUsefulContacts = async ({ token }: { token: string }) => {
        const { data } = await GetUsefulContacts({ token });

        if (data) {
            setDataUsefulContacts(data);
        }
    }

    const handlePostUpdatePlate = async ({ token, body }: { token: string, body: ParamsBodyUpdatePlate }) => {
        const { data } = await PostUpdatePlate({ token, body });

        if (data) {
            setDataUpdatePlate({ isSuccess: true, msg: data });
        } else {
            setDataUpdatePlate({ isSuccess: false, msg: 'error' });
        }
    }

    return { dataUsefulContacts, dataUpdatePlate, handleGetUsefulContacts, handlePostUpdatePlate, handleClearVehicles };
}

export default useMyVehicles;